import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css';
import { createHead } from '@vueuse/head'

const app = createApp(App)
const head = createHead()
app.use(router)
app.use(head)
app.mount('#app')
